var _excluded = ["className", "active", "onClick", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { noop, triggerOnKeys } from '../../utils';
import classnames from 'classnames';
var ENTER_KEY_CODE = 13;
var propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node
};
var defaultProps = {
  className: '',
  active: false,
  onClick: noop
};
function PageLink(_ref) {
  var className = _ref.className,
    active = _ref.active,
    onClick = _ref.onClick,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("li", {
    className: classnames(className, {
      active: active
    })
  }, /*#__PURE__*/React.createElement("a", _extends({
    onClick: onClick,
    onKeyPress: triggerOnKeys(onClick, ENTER_KEY_CODE) // keyboard interaction requirement
    ,
    "aria-current": active ? 'page' : false,
    tabIndex: "0" // add back to natural tab order (automatically removed without an href)
  }, rest), children));
}
PageLink.propTypes = propTypes;
PageLink.defaultProps = defaultProps;
export default PageLink;